import {environment} from './../../../environments/environment';

class LocalConsole {
  public log(...data) {
    if (environment.local || environment.sit) {
      console.log(...data);
    }
  }
}

export const localConsole = new LocalConsole();
